<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
      ></loading>
    </div>
    <!-- Header -->
    <div class="header bg-white py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-black" style="font-size: 35px">
                Setting Up System
              </h1>
              <span
                class="text-lead text-light"
                style="font-size: 20px"
                v-if="isLoading === true"
                >Please wait</span
              >
              <span class="text-lead text-light" v-else>
                <ul class="list-group list-group-flush" data-toggle="checklist">
                  <li
                    class="list-group-item px-0"
                    v-for="item in items"
                    :key="item.id"
                  >
                    <div
                      class="checklist-item"
                      :class="{
                        'checklist-item-checked': item.done,
                        [`checklist-item-${item.checkType}`]: item.checkType
                      }"
                    >
                      <div class="checklist-info">
                        <h5 class="checklist-title mb-0">
                          {{ item.title }} (Records = {{ item.count }})
                        </h5>
                      </div>
                      <div>
                        <base-checkbox
                          disabled
                          checked
                          :type="item.checkType"
                        />
                      </div>
                    </div>
                  </li>
                </ul>
                <p v-if="continueButton" style="padding: 10px">
                  <base-button type="success" @click.native="handleContinue()">
                    <span class="btn-inner--text">Continue</span>
                  </base-button>
                </p>
                <p v-else style="padding: 10px">
                  <base-button type="warning" @click.native="syncBoundaries()">
                    <span class="btn-inner--text">Sync Admin Boundaries</span>
                  </base-button>
                  <base-button type="danger" @click.native="handleGoback()">
                    <span class="btn-inner--text">Go back</span>
                  </base-button>
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import { check } from "@/api/check";
import { user } from "@/api/user";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import swal from "sweetalert2";
import copyHelper from "../../../sync/helpers/copy";
import { mapGetters, mapActions } from "vuex";
//import winston from "../../../sync/config/winston";
//import config from "../../../sync/config/app";
import Localbase from "localbase";
import admin1s from "../../../sync/api/location/admin1s";
const db = new Localbase("db_dmis_desktop");
db.config.debug = true;

export default {
  components: { Loading },
  name: "setup-page",
  data() {
    return {
      isLoading: true,
      fullPage: true,
      admin1s: { id: 1, title: "Admin 1s", count: 0, checkType: "danger" },
      admin2s: { id: 2, title: "Admin 2s", count: 0, checkType: "danger" },
      admin3s: { id: 3, title: "Admin 3s", count: 0, checkType: "danger" },
      admin3gvhs: {
        id: 4,
        title: "Admin 3 Gvhs",
        count: 0,
        checkType: "danger"
      },
      admin3gvhvillages: {
        id: 5,
        title: "Admin 3 Gvh Villages",
        count: 0,
        checkType: "danger"
      },
      error: {
        status: false,
        message: ""
      },
      items: [],
      continueButton: false
    };
  },
  computed: {
    ...mapGetters({
      getAdmin1s: "dims/getAdmin1s",
      getAdmin2s: "dims/getAdmin2s",
      getAdmin3s: "dims/getAdmin3s",
      getAdmin3gvhs: "dims/getAdmin3gvhs",
      getAdmin3gvhvillages: "dims/getAdmin3gvhvillages"
    })
  },
  methods: {
    ...mapActions({
      setAdmin1s: "dims/Admin1s",
      setAdmin2s: "dims/Admin2s",
      setAdmin3s: "dims/Admin3s",
      setAdmin3gvhs: "dims/Admin3gvhs",
      setAdmin3gvhvillages: "dims/Admin3gvhvillages",
      setUser: "users/setUser"
    }),
    async syncBoundaries() {
      check
        .admin1s()
        .then(
          async response => {
            if (response.length > 0) {
              await this.setAdmin1s(response);
              this.admin1s = {
                id: 1,
                title: "Admin 1s",
                count: response.length,
                checkType: response.length < 1 ? "danger" : "success"
              };
            } else {
              await this.admin1();
            }
          },
          reason => {
            this.error = { status: true, message: reason };
          }
        )
        .finally(() => {
          this.items.push(this.admin1s);
        });
      check
        .admin2s()
        .then(
          async response => {
            if (response.length > 0) {
              await this.setAdmin2s(response);
              this.admin2s = {
                id: 2,
                title: "Admin 2s",
                count: response.length,
                checkType: response.length < 1 ? "danger" : "success"
              };
            } else {
              await this.admin2();
            }
          },
          reason => {
            this.error = { status: true, message: reason };
          }
        )
        .finally(() => {
          this.items.push(this.admin2s);
        });
      check
        .admin3s()
        .then(
          async response => {
            if (response.length > 0) {
              await this.setAdmin3s(response);
              this.admin3s = {
                id: 3,
                title: "Admin 3s",
                count: response.length,
                checkType: response.length < 1 ? "danger" : "success"
              };
            } else {
              await this.admin3();
            }
          },
          reason => {
            this.error = { status: true, message: reason };
          }
        )
        .finally(() => {
          this.items.push(this.admin3s);
        });
      check
        .admin3gvhs()
        .then(
          async response => {
            if (response.length > 0) {
              await this.setAdmin3gvhs(response);
              this.admin3gvhs = {
                id: 4,
                title: "Admin 3 Gvhs",
                count: response.length,
                checkType: response.length < 1 ? "danger" : "success"
              };
            } else {
              await this.admin3gvh();
            }
          },
          reason => {
            this.error = { status: true, message: reason };
          }
        )
        .finally(() => {
          this.items.push(this.admin3gvhs);
        });
      check
        .admin3gvhvillages()
        .then(
          async response => {
            if (response.length > 0) {
              await this.setAdmin3gvhvillages(response);
              this.admin3gvhvillages = {
                id: 5,
                title: "Admin 3 Gvh Villages",
                count: response.length,
                checkType: response.length < 1 ? "danger" : "success"
              };
            } else {
              await this.admin3gvhvillage();
            }
          },
          reason => {
            this.error = { status: true, message: reason };
          }
        )
        .finally(() => {
          this.items.push(this.admin3gvhvillages);
          if (this.error.status != true) {
            this.isLoading = false;
            if (
              this.admin1s.count != 0 &&
              this.admin2s.count != 0 &&
              this.admin3s.count != 0
            ) {
              this.continueButton = true;
              swal({
                title: "Succesfully loaded configurational data",
                text: "The system is now ready for usage",
                type: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              });
            } else {
              //Clean User Account
              user.clean();
              //Error
              swal({
                title: "Failed to load configurational data",
                text: "Please reffer to technical personel (Data corrupted)",
                type: "error",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              });
            }
          } else {
            this.isLoading = false;
            //Clean User Account
            user.clean();
            //Error
            swal({
              title: "System error",
              text:
                "Please reffer to technical personel (" +
                this.error.message +
                ")",
              type: "error",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          }
        });
    },
    async admin1() {
      let admin1s = await copyHelper.admin1Boundaries();

      await this.setAdmin1s([...admin1s]);

      await this.getAdmin1s.forEach(element => {
        db.collection("admin_1").add(element, element._id);
      });

      this.admin1s = {
        id: 1,
        title: "Admin 1s",
        count: this.getAdmin1s.length,
        checkType: this.getAdmin1s.length < 1 ? "danger" : "success"
      };
    },
    async admin2() {
      let admin2s = await copyHelper.admin2Boundaries();

      await this.setAdmin2s([...admin2s]);

      await this.getAdmin2s.forEach(element => {
        db.collection("admin_2").add(element, element._id);
      });

      this.admin2s = {
        id: 2,
        title: "Admin 2s",
        count: this.getAdmin2s.length,
        checkType: this.getAdmin2s.length < 1 ? "danger" : "success"
      };
    },
    async admin3() {
      let admin3s = await copyHelper.admin3Boundaries();

      await this.setAdmin3s([...admin3s]);

      await this.getAdmin3s.forEach(element => {
        db.collection("admin_3").add(element, element._id);
      });

      this.admin3s = {
        id: 3,
        title: "Admin 3s",
        count: this.getAdmin3s.length,
        checkType: this.getAdmin3s.length < 1 ? "danger" : "success"
      };
    },
    async admin3gvh() {
      let admin3gvhs = await copyHelper.admin3gvhsBoundaries();

      await this.setAdmin3gvhs([...admin3gvhs]);

      await this.getAdmin3gvhs.forEach(element => {
        db.collection("admin_3gvhs").add(element, element._id);
      });

      this.admin3gvhs = {
        id: 4,
        title: "Admin 3 Gvhs",
        count: this.getAdmin3gvhs.length,
        checkType: this.getAdmin3gvhs.length < 1 ? "danger" : "success"
      };
    },
    async admin3gvhvillage() {
      let admin3gvhvillages = await copyHelper.admin3gvhvillagesBoundaries();

      await this.setAdmin3gvhvillages([...admin3gvhvillages]);

      await this.getAdmin3gvhvillages.forEach(element => {
        db.collection("admin_3gvhvillages").add(element, element._id);
      });

      this.admin3gvhvillages = {
        id: 5,
        title: "Admin 3 Gvh Villages",
        count: this.getAdmin3gvhvillages.length,
        checkType: this.getAdmin3gvhvillages.length < 1 ? "danger" : "success"
      };
    },

    handleContinue() {
      this.$router.push({ name: "Dashboard", params: {} });
    },
    handleGoback() {
      this.$router.push({ name: "Login", params: {} });
    }
  },
  async beforeMount() {
    await this.syncBoundaries();
  },
  created() {},
  watch: {
    // items: function (val) {
    //   if (val.length == 5) {
    //     if (this.error.status != true) {
    //       this.isLoading = false;
    //       if (
    //         this.admin1s.count != 0 &&
    //         this.admin2s.count != 0 &&
    //         this.admin3s.count != 0
    //       ) {
    //         this.continueButton = true;
    //         swal({
    //           title: "Succesfully loaded configurational data",
    //           text: "The system is now ready for usage",
    //           type: "success",
    //           confirmButtonClass: "btn btn-success btn-fill",
    //           buttonsStyling: false,
    //         });
    //       } else {
    //         //Clean User Account
    //         user.clean();
    //         //Error
    //         swal({
    //           title: "Failed to load configurational data",
    //           text: "Please reffer to technical personel (Data corrupted)",
    //           type: "error",
    //           confirmButtonClass: "btn btn-success btn-fill",
    //           buttonsStyling: false,
    //         });
    //       }
    //     } else {
    //       this.isLoading = false;
    //       //Clean User Account
    //       user.clean();
    //       //Error
    //       swal({
    //         title: "System error",
    //         text:
    //           "Please reffer to technical personel (" +
    //           this.error.message +
    //           ")",
    //         type: "error",
    //         confirmButtonClass: "btn btn-success btn-fill",
    //         buttonsStyling: false,
    //       });
    //     }
    //   }
    // },
  }
};
</script>
